var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 187,
    viewBox: "0 0 187 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 187,
    rx: 93.5,
    fill: "url(#paint0_linear_6931_17829)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6931_17829",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 187
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 187,
    rx: 93.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6931_17829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9016 159.152C70.4279 167.54 59.5233 210.413 54.6302 230.801C26.1104 228.843 9.66017 219.034 5 214.374L40.6499 131.89C39.9509 131.191 38.6926 126.438 39.2519 113.017C39.9509 96.2404 50.4361 57.7944 51.8341 52.9014C53.2322 48.0084 56.0282 47.6587 59.5233 50.8042C62.3194 53.3207 65.1154 69.7941 66.1639 77.7163L79.4452 86.454C93.076 77.0173 121.526 57.5149 126.279 54.9985C132.221 51.8529 137.464 50.4549 139.561 52.9014C141.658 55.348 141.658 58.4935 137.464 62.6876C134.108 66.0429 126.512 69.6778 123.134 71.0758V73.5223C124.532 72.4738 128.446 71.0059 132.92 73.5223C138.448 76.6321 137.145 78.7171 133.737 84.1675L133.619 84.3571C130.823 88.8308 126.862 89.7162 125.231 89.5997L121.386 93.0948L125.231 91.6967C127.095 91.2307 131.662 91.5569 135.017 96.5898C137.706 100.624 132.792 105.825 128.336 109.17C129.976 108.658 131.909 108.937 133.619 111.269C137.464 116.512 130.473 123.502 126.279 124.9C122.924 126.018 120.92 124.434 120.338 123.502C119.173 124.201 113.977 128.255 102.513 138.88C91.0489 149.505 79.3287 156.822 74.9016 159.152Z",
    fill: "#FFAE9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.726 72.1255C125.371 72.6847 123.018 73.2905 122.785 73.5235L121.387 79.4651L128.726 72.1255Z",
    fill: "#F19A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.181 92.0464H127.327L123.482 94.8424L124.181 92.0464Z",
    fill: "#F19A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.183 109.871L128.377 109.172L124.532 111.968L124.183 109.871Z",
    fill: "#F19A87"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9209,
    y: 20,
    width: 61.6104,
    height: 133.609,
    rx: 4.31525,
    fill: "white",
    stroke: "#07015B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 110,
    width: 48,
    height: 15.3333,
    rx: 2.33333,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.388 116.557C86.388 117.736 85.6164 118.542 84.4373 118.542H83.7263V120.667H82.2438V114.598H84.4286C85.6597 114.598 86.388 115.36 86.388 116.557ZM84.2292 115.872H83.7263V117.268H84.2118C84.6453 117.268 84.8708 116.973 84.8708 116.557C84.8708 116.149 84.6367 115.872 84.2292 115.872ZM90.0016 119.305H88.0942L87.6607 120.667H86.1694L88.2676 114.598H89.8282L91.9263 120.667H90.4351L90.0016 119.305ZM89.6201 118.092L89.0479 116.167L88.4757 118.092H89.6201ZM94.9259 120.667H93.452V117.927L91.5966 114.598H93.2613L94.189 116.583L95.1427 114.598H96.7813L94.9259 117.927V120.667ZM100.677 120.667H97.3739V114.598H100.608V115.924H98.8565V116.938H100.348V118.256H98.8565V119.34H100.677V120.667ZM105.683 116.462C105.683 117.129 105.397 117.762 104.842 118.066C104.842 118.066 104.833 118.048 106.238 120.667H104.599L103.515 118.421H103.064V120.667H101.582V114.598H103.559C104.989 114.598 105.683 115.256 105.683 116.462ZM103.437 115.872H103.064V117.181H103.507C103.914 117.181 104.166 116.93 104.166 116.514C104.166 116.115 103.975 115.872 103.437 115.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.7261 63.587L77.059 63.5802C76.2584 63.5769 75.6067 64.2232 75.6034 65.0238L75.5492 78.2045C75.5459 79.005 76.1922 79.6567 76.9928 79.66L78.6599 79.6669C79.4605 79.6702 80.1122 79.0238 80.1155 78.2233L80.1697 65.0426C80.173 64.242 79.5267 63.5903 78.7261 63.587Z",
    fill: "#1F1F40"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.3863 63.9098L87.7191 63.9029C86.9185 63.8996 86.2669 64.546 86.2636 65.3466L86.2093 78.5272C86.206 79.3278 86.8524 79.9795 87.653 79.9828L89.3201 79.9896C90.1207 79.9929 90.7723 79.3466 90.7756 78.546L90.8299 65.3654C90.8332 64.5648 90.1868 63.9131 89.3863 63.9098Z",
    fill: "#1F1F40"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M100.695 64.132L99.0277 64.1251C98.2271 64.1218 97.5755 64.7681 97.5722 65.5687L97.5179 78.7494C97.5146 79.55 98.161 80.2016 98.9616 80.2049L100.629 80.2118C101.429 80.2151 102.081 79.5688 102.084 78.7682L102.138 65.5875C102.142 64.7869 101.495 64.1353 100.695 64.132Z",
    fill: "#1F1F40"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.5085 78.7787L84.5651 65.0116C84.5677 64.3797 84.0575 63.8652 83.4256 63.8626C82.7936 63.86 82.2791 64.3702 82.2765 65.0022L82.2199 78.7693C82.2173 79.4013 82.7275 79.9157 83.3595 79.9183C83.9915 79.9209 84.5059 79.4107 84.5085 78.7787Z",
    fill: "#1F1F40"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M95.1686 79.1015L95.2253 65.3344C95.2279 64.7024 94.7177 64.188 94.0857 64.1854C93.4537 64.1828 92.9393 64.693 92.9367 65.325L92.88 79.0921C92.8774 79.724 93.3876 80.2385 94.0196 80.2411C94.6516 80.2437 95.166 79.7335 95.1686 79.1015Z",
    fill: "#1F1F40"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M111.758 79.1611L111.814 65.394C111.817 64.762 111.307 64.2475 110.675 64.2449C110.043 64.2423 109.528 64.7526 109.526 65.3845L109.469 79.1516C109.466 79.7836 109.977 80.298 110.608 80.3006C111.24 80.3032 111.755 79.793 111.758 79.1611Z",
    fill: "#1F1F40"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M107.123 79.2226L107.179 65.4555C107.182 64.8235 106.672 64.3091 106.04 64.3065C105.408 64.3039 104.893 64.8141 104.891 65.4461L104.834 79.2132C104.832 79.8451 105.342 80.3596 105.974 80.3622C106.606 80.3648 107.12 79.8546 107.123 79.2226Z",
    fill: "#1F1F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0504 58.2546L73.039 58.2341C70.3704 58.2232 68.1982 60.3777 68.1873 63.0464L68.1842 63.7995",
    stroke: "#F3E226",
    strokeWidth: 0.966408,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.942 84.9113L72.9306 84.8908C70.262 84.8799 68.1075 82.7077 68.1184 80.0391L68.1215 79.286",
    stroke: "#F3E226",
    strokeWidth: 0.966408,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.97 58.3807L113.981 58.4012C116.65 58.4121 118.805 60.5843 118.794 63.2529L118.791 64.006",
    stroke: "#F3E226",
    strokeWidth: 0.966408,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.916 85.0384L113.928 85.0589C116.596 85.0698 118.769 82.9153 118.78 80.2466L118.783 79.4935",
    stroke: "#F3E226",
    strokeWidth: 0.966408,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.533 75.9823C135.135 72.627 130.591 72.0212 128.494 72.1377L124.999 75.2831C120.805 78.4396 121.154 86.8168 123.251 88.2148C125.348 89.6129 126.397 90.6614 130.591 88.2148C134.785 85.7683 138.28 80.1764 136.533 75.9823Z",
    fill: "#FCAA95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.093 81.2116C131.534 79.2543 129.996 78.532 129.297 78.4155C129.064 78.4155 128.039 78.8349 125.802 80.5126C123.006 82.6096 123.705 84.7067 124.753 86.1047C125.802 87.5027 128.249 87.8522 129.297 86.8037C130.346 85.7552 132.792 83.6581 132.093 81.2116Z",
    fill: "#FFC2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.366 96.9395C134.248 93.025 129.541 92.0464 127.328 92.0464C126.862 92.0464 124.881 93.1648 120.687 97.6385C115.444 103.231 119.638 109.172 121.735 109.871C123.832 110.57 127.328 109.172 129.774 107.075C132.221 104.978 136.764 101.833 135.366 96.9395Z",
    fill: "#FCAA95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.475 113.731C134.446 110.084 130.115 109.172 128.078 109.172C127.65 109.172 125.827 110.214 121.968 114.382C117.144 119.592 121.003 125.128 122.933 125.779C124.863 126.43 128.078 125.128 130.33 123.174C132.581 121.22 136.762 118.289 135.475 113.731Z",
    fill: "#FCAA95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.522 101.483C130.962 99.2466 128.259 98.4544 126.978 98.3379C126.628 98.3379 125.65 98.5476 124.531 99.3864C123.133 100.435 119.988 102.881 121.036 105.328C122.085 107.775 125.23 107.775 126.628 107.425C128.026 107.076 132.221 104.28 131.522 101.483Z",
    fill: "#FFC2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.754 118.255C130.261 116.271 127.879 115.568 126.75 115.464C126.442 115.464 125.58 115.65 124.594 116.395C123.362 117.325 120.811 119.934 121.735 122.105C122.659 124.276 125.21 123.837 126.442 123.527C127.674 123.217 131.37 120.736 130.754 118.255Z",
    fill: "#FFC2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1242 150.414C48.8972 144.822 42.6294 135.036 40.6489 131.191L38.7881 135.973C42.423 141.845 53.1146 147.851 58.1242 150.414Z",
    fill: "#F19A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4648 156.356C68.5405 158.593 73.0375 159.152 74.9015 159.152L73.3922 162.272C69.1982 160.874 66.5134 157.754 65.4648 156.356Z",
    fill: "#F19A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.002 249.163C199.002 255.963 206.502 266.997 210.002 271.663L214.002 281.164H162.002C155.336 272.664 139.302 254.364 128.502 249.163C115.001 242.663 109.002 231.164 102.002 219.664C95.0022 208.164 91.5002 202.164 89.5002 192.164C88.5002 187.163 90.5019 176.913 93.5023 176.164C96.5023 175.414 100.681 176.081 102.002 179.164C105.002 186.164 104.502 193.664 109.002 196.664C113.503 199.664 118.002 207.164 128.502 207.664C139.002 208.164 144.502 204.164 144.502 188.164C144.502 172.164 118.002 156.664 109.002 146.164C100.002 135.664 94.0022 131.163 102.002 124.663C110.002 118.163 120.502 132.163 132.502 141.663C142.102 149.263 149.502 157.497 152.002 160.663C155.336 160.663 164.202 161.463 173.002 164.663C184.002 168.663 179.002 165.663 186.002 181.663C193.002 197.663 194.502 240.663 197.002 249.163Z",
    fill: "#FFAE9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5 127.664C99.5004 131.264 104 135.497 106.5 137.164L115 129.664C114.333 128.997 112.5 127.364 110.5 126.164C108 124.664 104 123.164 101.5 127.664Z",
    fill: "#FFC2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.766 184.164C96.766 178.564 93.766 176.83 92.266 176.664C91.5993 178.164 90.066 182.064 89.266 185.664C88.266 190.164 90.266 189.664 92.266 189.664C94.266 189.664 96.766 191.164 96.766 184.164Z",
    fill: "#FFC2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 172.163L152 160.663C153.833 159.997 158 160.664 159 161.163C160.789 162.058 160.833 169.163 161 172.163Z",
    fill: "#F19A87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6931_17829",
    x1: 0,
    y1: 0,
    x2: 337.317,
    y2: 39.8696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.a9fb70456748b22ce44d50e7b392b7cd.svg";
export { ForwardRef as ReactComponent };